module.exports = __webpack_public_path__ + "img/horizontal_4_7_5010.10afdffe.png";